module.exports = __webpack_public_path__ + "assets/img/theme_iris_thumbnail.9e3856e4.png";